import React from 'react';
import Routes from '../Routes';

function getModuleLoginPage() {
  // if(Routes.getData().module === 'reviewer' || Routes.getData().module === 'review_admin') {
  //   return '/ui/auth/reviewer';
  // }else if(Routes.getData().module === 'submitter' || Routes.getData().module === 'submitter_admin') {
    return '/ui/auth';
  // }
}

export default getModuleLoginPage;
